export type Hint = {
  text: string;
  after?: string[];
  hide?: string[];
  image?: string;
  title?: string;
  viewedOnOrientation?: string;
  viewedPastWidth?: string;
  visibleOnOrientation?: string;
  viewedOnPlatform?: string;
};

export const HINTS: { [key: string]: Hint } = {
  "0": {
    text: `Look at the frequency of the peak and the peak shape e.g. is the
    peak broad or sharp? Which region of the IR spectrum does the signal
    appear in?`,
  },
  "1": {
    text: `The integration of each peak provides information on the ‘relative
    ratio’ of hydrogens that the peak corresponds to. The sum of all the
    integrals should equal the total number of hydrogens present in the
    compound.`,
  },
  "2": {
    text: `Signal splitting (or multiplicity) refers to the effect that
    non-equivalent hydrogens have on the selected peak. Remember to use the n+1
    rule. For example, a CH3 group that is adjacent to CH2 will appear as a
    triplet.`,
  },
  "3": {
    text: `Remember that electronegative atoms such as oxygen or nitrogen will
    make the adjacent proton signal more deshielded and the chemical shift of
    the peak will appear further downfield.`,
  },
  "4": {
    text: `As you build the unknown molecule make sure that each functional
    group connection that you add provides the desired splitting pattern and
    chemical shift for the corresponding signals.`,
  },
  "5": {
    text: `Note: sample run as a nujol mull. Nujol will mask peaks between
    2800-2950cm.`,
  },
  "anise-nmr-3-5ppm-chemical-shift": {
    after: [],
    text: `Look at the chemical shift, what does that tell you about the
      environment those hydrogens are in? What must they be near to?`,
  },
  "anise-nmr-3-5ppm-review-ir": {
    after: ["anise-nmr-3-5ppm-chemical-shift"],
    text: `Review your IR analysis – you can use that to eliminate possible
      functional groups that could cause similar NMR shifts`,
  },
  "anise-nmr-table": {
    after: [],
    text: `The highlighted hydrogen(s) are not correlated to integration value
    – there may be multiple of that type of hydrogen represented by this peak.`,
  },
  "anise-aromatic-peaks-hyperfine": {
    text: `Ignore very small splitting/low level splitting (this is called
      hyperfine splitting, and is an advanced topic).`,
  },
  "anise-aromatic-peaks-lean": {
    after: ["anise-aromatic-peaks-hyperfine"],
    text: `Peaks will sometimes “lean” towards each other, causing the peak to
      look less symmetric`,
  },
  "build-aromatic-substitution": {
    text: `For aromatic substitution, the splitting pattern in the NMR will
      tell you where groups are located on the ring. Review your 1H NMR
      splitting patterns for the aromatic peaks.`,
  },
  "rotate-screen": {
    image: `rotate-screen.svg`,
    text: `Rotate Your Screen to Reveal More of the Graph`,
    viewedOnOrientation: "landscape",
    viewedPastWidth: "480px",
    visibleOnOrientation: "portrait",
    viewedOnPlatform: "core",
  },
  "manipulate-graph": {
    image: `manipulate-graph.png`, //TODO: SVG version eventually
    title: "Graph Controls",
    text: `Pinch the graph to zoom. Pan the graph to find the peak you
      want. Tap a peak to select it.`,
    visibleOnOrientation: "landscape",
    viewedOnPlatform: "core",
    after: ["rotate-screen"],
  },
};
